/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Label_ApprovedInputs */

const en_wb_label_approved = /** @type {(inputs: Wb_Label_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approved by you`)
};

const lv_wb_label_approved = /** @type {(inputs: Wb_Label_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūs apstiprinājāt`)
};

/**
* | output |
* | --- |
* | "Approved by you" |
*
* @param {Wb_Label_ApprovedInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_label_approved = /** @type {((inputs?: Wb_Label_ApprovedInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Label_ApprovedInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_label_approved(inputs)
	return en_wb_label_approved(inputs)
});